"use strict";

exports.__esModule = true;
exports.createLinearScaleWithPadding = createLinearScaleWithPadding;
var _d3Scale = require("d3-scale");
/**
 * Create a linear scale with padding.
 */
function createLinearScaleWithPadding(from, to, values) {
  return (0, _d3Scale.scaleLinear)().rangeRound([from, to]).domain(generateMinMaxWithPadding(values));
}
function generateMinMaxWithPadding(values) {
  var min = Math.min.apply(Math, values);
  var max = Math.max.apply(Math, values);
  var padding = (max - min) * 0.1;
  return [min - padding, max + padding];
}